<div class="card panel-flat-color primary-panel">
    <div class="panel-flat-header">
        <h3>Overview</h3>
    </div>
    <div class="panel-flat-body position-relative" style="min-height: initial">
        <div class="referral-field-grid" [formGroup]="form()">
            <span class="referral-field-label">System ID</span>
            <span>{{ referral()?.litigationReferralId }}</span>

            <span class="referral-field-label">Referral ID</span>
            <span>{{ referral()?.matterId }}</span>

            <span class="referral-field-label">Operation ID</span>
            <span>{{ referral()?.operationId }}</span>

            <span class="referral-field-label">RLS Due Date</span>
            <referral-input-with-revert
                formControlName="rlsDueDate"
                [systemValue]="systemReferral()?.rlsDueDate"
                [originalValue]="originalReferral()?.rlsDueDate"
                [isDate]="true"
            />

            <label class="referral-field-label">Have NOD?</label>
            <referral-input-with-revert
                formControlName="haveNOD"
                [systemValue]="systemReferral()?.haveNOD"
                [originalValue]="originalReferral()?.haveNOD"
                [isBoolean]="true"
                [customWidth]="120"
            />

            @if (form().get('haveNOD')?.value) {
                <label class="referral-field-label">NOD Date</label>
                <referral-input-with-revert
                    formControlName="nodDate"
                    [systemValue]="systemReferral()?.nodDate"
                    [originalValue]="originalReferral()?.nodDate"
                    [isDate]="true"
                />
            }

            <label class="referral-field-label" for="casePriorityId">Case Priority</label>
            <referral-input-with-revert
                formControlName="casePriorityId"
                [systemValue]="systemReferral()?.casePriorityId"
                [originalValue]="originalReferral()?.casePriorityId"
                [selectOptions]="rlsCasePriorityOptions"
                [isNumber]="true"
                [customWidth]="120"
            />
        </div>
    </div>
</div>
